import { fromAsync } from "../../async/static/fromAsync.js";
export const whereAsync = (source, predicate) => {
    if (predicate.length === 1) {
        return whereAsync1(source, predicate);
    }
    else {
        return whereAsync2(source, predicate);
    }
};
const whereAsync1 = (source, predicate) => {
    async function* generator() {
        for (const item of source) {
            if (await predicate(item) === true) {
                yield item;
            }
        }
    }
    return fromAsync(generator);
};
const whereAsync2 = (source, predicate) => {
    async function* generator() {
        let i = 0;
        for (const item of source) {
            if (await predicate(item, i++) === true) {
                yield item;
            }
        }
    }
    return fromAsync(generator);
};
